<script>
  import { createEventDispatcher } from "svelte";
  import RowsContainer from "../container/RowsContainer.svelte";
  import StepperHeadline from "../stepper/StepperHeadline.svelte";
  import Loading from "../display/Loading.svelte";
  import EmailEdit from "../edit/EmailEdit.svelte";

  import Image from "../display/Image.svelte";
  import { showLoading } from "../../stores/mainStore";
  export let model;

  const dispatch = createEventDispatcher();
  const submit = () => dispatch("emailSubmit");
</script>

<StepperHeadline noBold={true} noMaxWidth={true}>
  <!-- <h1>Incredible, don’t you think?</h1>
  <p>
    GETitOUT is the first marketing generator that creates
    <b>your texts, your visuals and your campaigns</b>
    . No marketing experience necessary.
  </p> -->
  <h1>
    Be the first to <b>create all your <br />marketing assets in minutes</b>
    when<br /> GETitOUT launches in <b>April 2021</b>.
  </h1>
</StepperHeadline>
<div class="text-center mx-auto max-w-lg">
  <EmailEdit bind:model={model.user} on:save={submit} noHeadline={true} />
</div>
<div class="relative">
  <RowsContainer>
    <div class="text-center">
      <div class="flex flex-row">
        <span class="flex-grow" />
        <svg class="text-xl h-6 my-auto mr-2" viewBox="0 0 24 24">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.8523 0C5.30983 0 0 5.30983 0 11.8523C0 18.3948 5.30983
            23.7046 11.8523 23.7046C18.3948 23.7046 23.7046 18.3948 23.7046
            11.8523C23.7046 5.30983 18.3948 0 11.8523 0ZM2.37025 11.8525C2.37025
            11.1296 2.46507 10.4184 2.61915 9.74284L8.28455
            15.4082V16.5935C8.28455 17.8972 9.35125 18.9639 10.655
            18.9639V21.2514C5.99706 20.6588 2.37025 16.6764 2.37025
            11.8525ZM16.5816 16.5928C17.6483 16.5928 18.5254 17.2921 18.8335
            18.2521C20.3743 16.5691 21.3344 14.3172 21.3344 11.8519C21.3344
            7.88138 18.8691 4.46792 15.3964 3.06935V3.55529C15.3964 4.85904
            14.3297 5.92575 13.0259 5.92575H10.6555V8.29621C10.6555 8.94808
            10.1221 9.48144 9.47024 9.48144H7.09978V11.8519H14.2112C14.863
            11.8519 15.3964 12.3853 15.3964 13.0371V16.5928H16.5816Z"
          />
        </svg>

        <h2 class="text-2xl">Your Website Hero</h2>
        <span class="flex-grow" />
      </div>
      {#if model.website.previewUrlPaths.websiteHero != null}
        <Image
          src={model.website.previewUrlPaths.websiteHero}
          isExternal={true}
          class="shadow-2xl rounded-lg mt-2"
        />
      {/if}
    </div>

    <!-- <div class="sm:hidden">
      <div
        class="bg-black text-white px-4 py-5 shadow rounded-lg">
        <EmailEdit
          bind:model={model.user}
          on:save={submit} 
          darkMode={true} />
      </div>
    </div> -->

    <div class="text-center">
      <div class="flex flex-row">
        <span class="flex-grow" />
        <svg class="text-xl h-6 my-auto mr-2" viewBox="0 0 25 24">
          <path
            d="M-9.3147e-07 2.69046C-7.56895e-07 6.68425 2.85321 12.0391 7.75855
            15.6363L7.75855 18.6191C7.75855 20.7733 9.4344 22.0078 11.2053
            22.8586L13.5775 24L13.5775 18.6191L16.4869 15.8262L19.3964
            13.0334L25 13.0334L23.8129 10.7562C22.9285 9.05632 21.6405 7.44763
            19.3964 7.44763L16.2891 7.44763C12.5417 2.73887 6.96136 1.60306e-06
            2.80278 1.78484e-06L-1.04907e-06 1.90735e-06L-9.3147e-07
            2.69046ZM5.81892 7.44763C5.81892 6.95382 6.02327 6.48024 6.38702
            6.13107C6.75078 5.78189 7.24413 5.58573 7.75855 5.58573C8.27298
            5.58573 8.76633 5.78189 9.13009 6.13107C9.49384 6.48024 9.69819
            6.95382 9.69819 7.44763C9.69819 7.94144 9.49384 8.41503 9.13009
            8.7642C8.76633 9.11338 8.27298 9.30954 7.75855 9.30954C7.24413
            9.30954 6.75078 9.11338 6.38702 8.7642C6.02327 8.41503 5.81892
            7.94144 5.81892 7.44763ZM17.4567 19.55L18.4266 20.481C19.827 21.8253
            23.2757 22.3429 23.2757 22.3429C23.2757 22.3429 22.8916 19.1814
            21.336 17.6881L20.3662 16.7572L17.4567 19.55Z"
          />
        </svg>

        <h2 class="text-2xl">Your Product Hunt Profile</h2>
        <span class="flex-grow" />
      </div>
      {#if model.website.previewUrlPaths.productHunt != null}
        <Image
          isExternal={true}
          src={model.website.previewUrlPaths.productHunt}
          class="shadow-2xl rounded-lg mt-2"
        />
      {/if}
    </div>
  </RowsContainer>
  {#if $showLoading}
    <div
      class="absolute top-0 left-0 w-full h-full bg-white"
      style="min-height:500px;"
    >
      <Loading mode={2} />
    </div>
  {/if}
</div>
